import { render, staticRenderFns } from "./UiSnackbarContainer.vue?vue&type=template&id=7bacb162"
import script from "./UiSnackbarContainer.vue?vue&type=script&lang=js"
export * from "./UiSnackbarContainer.vue?vue&type=script&lang=js"
import style0 from "./UiSnackbarContainer.vue?vue&type=style&index=0&id=7bacb162&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports